import React from "react";

// Last line of defence for the public pages (revosdirector.com and getvynko.com).
// A page chunk that cannot be loaded (a flaky connection, or a deploy that replaced the file
// twice within the reload cooldown, see lib/lazyRetry.js) or a page that throws while rendering
// used to leave a blank white screen. This shows a short message with a reload button instead.
// Brand-neutral on purpose: it must render even when the brand or i18n code is what failed.

const COPY = {
  en: { title: "This page could not be loaded", body: "Please check your connection and try again.", button: "Reload the page" },
  es: { title: "No se pudo cargar esta página", body: "Revisa tu conexión e inténtalo de nuevo.", button: "Recargar la página" },
};

export default class PublicErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error("Public page failed to load or render", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const isSpanish = typeof window !== "undefined" && /^\/es(\/|$)/.test(window.location.pathname);
    const t = isSpanish ? COPY.es : COPY.en;
    return (
      <main
        id="main"
        role="alert"
        style={{ maxWidth: 520, margin: "0 auto", padding: "96px 24px", textAlign: "center", fontFamily: "Georgia, serif", color: "#1f1c17" }}
      >
        <h1 style={{ fontSize: 28, margin: "0 0 12px", fontWeight: 400 }}>{t.title}</h1>
        <p style={{ margin: "0 0 24px", color: "#5a5548", fontFamily: "system-ui, sans-serif" }}>{t.body}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ padding: "14px 24px", minHeight: 48, border: 0, borderRadius: 4, background: "#a5401c", color: "#fff", fontSize: 16, cursor: "pointer" }}
        >
          {t.button}
        </button>
      </main>
    );
  }
}
